import { NavLink } from "react-router-dom";
import { CalendarClock, Coins, FileText, Landmark, Layers, LayoutDashboard } from "lucide-react";
import { cn } from "@/lib/utils";
import { CispayLogo } from "@/components/cispay-logo";
import { paths } from "@/routes/paths";
import { useAuthStore } from "@/stores/auth.store";
import { isSuperAdmin } from "@/lib/permissions";

const items = [
  { to: paths.HOME, label: "Início", icon: LayoutDashboard, superAdminOnly: false },
  { to: paths.PAYMENT_BATCHES, label: "Lotes de Pagamento", icon: Layers, superAdminOnly: false },
  { to: paths.SIM_BANK, label: "Interface com o Banco", icon: Landmark, superAdminOnly: true },
  { to: paths.SELLERS_BALANCES, label: "Saldo dos Sellers", icon: Coins, superAdminOnly: false },
  { to: paths.SELLER_STATEMENT, label: "Extrato de Seller", icon: FileText, superAdminOnly: true },
  { to: paths.AUTO_WITHDRAW, label: "Saque Automático", icon: CalendarClock, superAdminOnly: true },
];

export function Sidebar() {
  const user = useAuthStore((s) => s.user);
  const visibleItems = items.filter((item) => !item.superAdminOnly || isSuperAdmin(user));

  return (
    <aside className="hidden w-64 shrink-0 border-r bg-card md:flex md:flex-col">
      <div className="flex h-14 items-center gap-2 border-b px-4">
        <CispayLogo height={28} />
        <span className="text-xs text-muted-foreground">Admin de Recursos</span>
      </div>
      <nav className="flex-1 space-y-1 p-2">
        {visibleItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === paths.HOME}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors",
                isActive
                  ? "bg-accent text-accent-foreground"
                  : "text-muted-foreground hover:bg-accent hover:text-accent-foreground",
              )
            }
          >
            <item.icon className="size-4 shrink-0" />
            {item.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
